import * as Yup from 'yup'

const menuDistributionAgeReportSchema = Yup.object().shape({
  period: Yup.string().required('Period is required'),
  menuType: Yup.string().required('Menu type is required'),
})

export default menuDistributionAgeReportSchema
